module.exports = __webpack_public_path__ + "static/media/60810025-3dE0wSgs.f0ae14dc.JPG";